import { Button, GetProp, Input, Space, Upload, UploadFile, UploadProps, Modal, Progress, Typography } from "antd";
import { FC, useState } from "react";
import { API } from "../../api";
import { useStore } from "../../config/store";
import { showProgressTextOnHeavyFiles } from "../../utils/progressUtils";
// import { API, URL } from "../api";

interface CodeBlockProps {
  submit: (text: string, file: any) => void;
  cancel: () => void;
  object_id: any;
  rent_id: any;
  clean_id: any;
}
type FileType = Parameters<GetProp<UploadProps, "beforeUpload">>[0];

export const CodeBlock: FC = () =>
  // export const CodeBlock: FC<CodeBlockProps> = (
  // { submit, cancel, object_id, rent_id, clean_id }
  {
    const [text, setText] = useState("");
    const [error, setError] = useState("");
    const [fileList, setFileList] = useState<UploadFile[]>([]);
    const [uploading, setUploading] = useState(false);

    const { clean, cancelDrawer, progressPercent, setProgress, progressText, setProgressText } = useStore();
    if (!clean) return null;
    const { date, cleantime, object, object_id, type, cost, rent_id, rent, comment, status, id } = clean;

    const submitHandler = async () => {
      // await API.addComment({ text, clean_id });
      if (text.length === 0) {
        setError("Нужно написать новый код");
        return;
      }
      if (fileList.length === 0) {
        setError("Нужно приложить фотографию нового кода");
        return;
      }
      setUploading(true);
      showProgressTextOnHeavyFiles(fileList, setProgressText);
      await API.changeKey({ curkey: text, object_id, rent_id, clean_id: id, file: fileList[0] }, setProgress);
      setProgressText("");
      setUploading(false);
      cancelDrawer();
      // submit(text, fileList[0]);
    };

    // const handleUpload = () => {
    //   const formData = new FormData();
    //   formData.append("file", fileList[0] as FileType);
    //   formData.append("key", text);
    //   setUploading(true);
    //   fetch(`${URL}/api/files/clean`, {
    //     method: "POST",
    //     body: formData,
    //   })
    //     .then((res) => res.json())
    //     .then(() => {
    //       setFileList([]);
    //       // message.success('upload successfully.');
    //     })
    //     .catch(() => {
    //       // message.error('upload failed.');
    //     })
    //     .finally(() => {
    //       setUploading(false);
    //     });
    // };

    const props: UploadProps = {
      onRemove: (file) => {
        const index = fileList.indexOf(file);
        const newFileList = fileList.slice();
        newFileList.splice(index, 1);
        setFileList(newFileList);
      },
      beforeUpload: (file) => {
        setFileList([...fileList, file]);

        return false;
      },
      fileList,
    };

    return (
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <div>Установите новый код кейбокса и введите в поле ниже</div>
        <Modal
          open={uploading}
          closable={false}
          footer={null}
          width={'fit-content'}
        >
          <Space direction="vertical" align="center" size="large" style={{ width: "100%" }}>
            <Progress
              percent={progressPercent}
              type="circle"
            />

            {progressText && <Typography.Text style={{ whiteSpace: "break-spaces" }}>{progressText}</Typography.Text>}
          </Space>
        </Modal>
        <Input onChange={(e) => setText(e.target.value)} size="large" />
        <Upload
          // action={`${URL}/api/files/clean/${cur?.rent?.id}`}
          {...props}
          // action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
          listType="picture"
          style={{ width: "100%", display: "block" }}
          // defaultFileList={fileList}
        >
          {fileList.length == 0 && (
            <Button
              // type="primary"
              block
              // icon={<UploadOutlined />}
            >
              Загрузить фото
            </Button>
          )}
        </Upload>
        {error && <div className="error">{error}</div>}
        <Button block size="large" type="primary" onClick={submitHandler} loading={uploading}>
          Отправить
        </Button>
        {/* <Button block size="large" type="primary" onClick={handleUpload}>
        Отправить фото
      </Button> */}
        <Button block size="large" onClick={cancelDrawer}>
          Отмена
        </Button>
      </Space>
    );
  };
